export default "__VITE_ASSET__CTbe43eH__"